export const SUBSCRIPTION_PRODUCT_CATEGORIES = {
  PROGUIDES_MEMBERSHIP: "proguides_membership",
  COACH_SUBSCRIPTION: "coach_subscription",
}



// WEBPACK FOOTER //
// ./src/store/user/subscriptions/subscriptions.constants.js